export default "/images/2703c0a48cc4a16daf879f7280c6b296.avif";